<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container fluid class="py-0" :class="{}">
            <v-row>
                <v-col style="position: relative">
                    <img alt="Hero Banner Image" src="/images/main/background.jpeg" :style="{
                        height: imageHeight
                    }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;
                        object-position: center;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white" class="mb-4" v-html="$t('titleScreens.privacy')"></h1>
                        <a :href="$getPhoneLink()">
                            <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                            }}</v-btn>
                        </a><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                        }}</small>
                    </div>
                </v-col>
            </v-row>


            <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
                :style="{ 'margin-top': isMobile ? '-78px' : '-138px' }" :height="isMobile ? 60 : 120"
                style="z-index: 2; position: relative;" />

        </v-container>

        <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920">
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10">
                    <article class="legal-doc">
                        <h2 class="legal-doc__title">Datenschutzerklärung</h2>

                        <h2>1. Verantwortlicher</h2>
                        <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
                        <address>
                            Rüdiger Keilberg<br />
                            Annastraße 9<br />
                            34119 Kassel<br />
                            Deutschland<br /><br />
                            Telefon: <a :href="phoneHref">{{ phone }}</a><br />
                            E-Mail: <a :href="mailto">{{ email }}</a>
                        </address>
                        <p>Tätigkeit: Heilpraktiker für Psychotherapie (Erlaubnis nach dem Heilpraktikergesetz,
                            beschränkt auf das Gebiet der Psychotherapie).</p>

                        <h2>2. Datenschutzbeauftragter</h2>
                        <p><span class="legal-doc__todo">[Sofern bestellt: Name und Kontaktdaten des
                                Datenschutzbeauftragten. Für eine Einzelpraxis ist die Bestellung in der Regel nicht
                                erforderlich (§&nbsp;38 BDSG). Ist keiner bestellt, kann dieser Abschnitt
                                entfallen.]</span></p>

                        <h2>3. Allgemeines zur Datenverarbeitung</h2>
                        <p>(1) Wir verarbeiten personenbezogene Daten unserer Nutzer und Patienten grundsätzlich nur,
                            soweit dies zur Bereitstellung einer funktionsfähigen Plattform sowie unserer Leistungen
                            erforderlich ist oder eine andere Rechtsgrundlage vorliegt.</p>
                        <p>(2) <strong>Rechtsgrundlagen</strong> der Verarbeitung sind insbesondere:</p>
                        <ul>
                            <li>Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO (Einwilligung),</li>
                            <li>Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Vertragserfüllung und vorvertragliche
                                Maßnahmen),</li>
                            <li>Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO (rechtliche Verpflichtung, z.&nbsp;B. steuer-
                                und berufsrechtliche Aufbewahrungspflichten),</li>
                            <li>Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigte Interessen).</li>
                        </ul>
                        <p>(3) Soweit wir <strong>Gesundheitsdaten</strong> und andere besondere Kategorien
                            personenbezogener Daten (Art.&nbsp;9 DSGVO) verarbeiten, stützen wir dies insbesondere auf
                            Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;h DSGVO i.&nbsp;V.&nbsp;m. §&nbsp;22 BDSG (Verarbeitung
                            zum Zweck der Gesundheitsversorgung und Behandlung durch Berufsgeheimnisträger) sowie
                            ergänzend auf eine ausdrückliche Einwilligung nach Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a
                            DSGVO. Näheres unter Ziffer&nbsp;10.</p>

                        <h2>4. Rechte der betroffenen Personen</h2>
                        <p>Sie haben im Rahmen der gesetzlichen Vorgaben folgende Rechte:</p>
                        <ul>
                            <li><strong>Auskunft</strong> über die Sie betreffenden verarbeiteten Daten (Art.&nbsp;15
                                DSGVO),</li>
                            <li><strong>Berichtigung</strong> unrichtiger Daten (Art.&nbsp;16 DSGVO),</li>
                            <li><strong>Löschung</strong> (Art.&nbsp;17 DSGVO),</li>
                            <li><strong>Einschränkung der Verarbeitung</strong> (Art.&nbsp;18 DSGVO),</li>
                            <li><strong>Datenübertragbarkeit</strong> (Art.&nbsp;20 DSGVO),</li>
                            <li><strong>Widerspruch</strong> gegen die Verarbeitung aus Gründen Ihrer besonderen
                                Situation, soweit die Verarbeitung auf Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO beruht
                                (Art.&nbsp;21 DSGVO),</li>
                            <li><strong>Widerruf</strong> einer erteilten Einwilligung mit Wirkung für die Zukunft
                                (Art.&nbsp;7 Abs.&nbsp;3 DSGVO).</li>
                        </ul>
                        <p>Zur Ausübung Ihrer Rechte genügt eine Mitteilung an die unter Ziffer&nbsp;1 genannten
                            Kontaktdaten.</p>
                        <p><strong>Beschwerderecht bei einer Aufsichtsbehörde:</strong> Sie haben das Recht, sich bei
                            einer Datenschutz-Aufsichtsbehörde zu beschweren (Art.&nbsp;77 DSGVO). Die für uns
                            zuständige Behörde ist: Der Hessische Beauftragte für Datenschutz und Informationsfreiheit,
                            Gustav-Stresemann-Ring&nbsp;1, 65189 Wiesbaden.</p>

                        <h2>5. Hosting und Bereitstellung der Plattform</h2>
                        <p>(1) Unsere Plattform (Website und zugehörige Anwendungen) wird bei der <strong>IONOS
                                SE</strong>, Elgendorfer Straße 57, 56410 Montabaur, gehostet. Die Daten werden in einem
                            Rechenzentrum in <strong>Deutschland</strong> verarbeitet, das nach
                            <strong>ISO/IEC&nbsp;27001</strong> zertifiziert ist und der Sicherheitsstufe
                            <strong>Tier&nbsp;III</strong> entspricht.
                        </p>
                        <p>(2) Die Verarbeitung erfolgt auf Grundlage unserer berechtigten Interessen an einer sicheren
                            und effizienten Bereitstellung unseres Angebots (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO)
                            sowie – soweit ein Vertrag betroffen ist – zur Vertragserfüllung (Art.&nbsp;6 Abs.&nbsp;1
                            lit.&nbsp;b DSGVO). Mit IONOS haben wir einen Vertrag zur Auftragsverarbeitung nach
                            Art.&nbsp;28 DSGVO geschlossen.</p>
                        <p>(3) <strong>Server-Logfiles:</strong> Bei jedem Zugriff auf die Plattform werden automatisch
                            Informationen erhoben, die Ihr Browser bzw. die App übermittelt, insbesondere: IP-Adresse,
                            Datum und Uhrzeit des Zugriffs, abgerufene Datei/aufgerufene Seite, übertragene Datenmenge,
                            Meldung über erfolgreichen Abruf, Browsertyp und -version, Betriebssystem und ggf. die zuvor
                            besuchte Seite (Referrer). Diese Daten dienen der Auslieferung der Inhalte, der
                            Gewährleistung von Stabilität und Sicherheit sowie der Fehleranalyse. Rechtsgrundlage ist
                            Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO. Die Logfiles werden nach <span
                                class="legal-doc__todo">[z.&nbsp;B. 7 / 14]</span> Tagen gelöscht, soweit sie nicht zur
                            Aufklärung eines konkreten Sicherheitsvorfalls länger benötigt werden.</p>

                        <h2>6. Cookies und Einwilligungsverwaltung (CCM19)</h2>
                        <p>(1) Wir verwenden Cookies und vergleichbare Technologien. Technisch notwendige Cookies, die
                            für den Betrieb der Plattform erforderlich sind (z.&nbsp;B. zur Sitzungsverwaltung und für
                            den Login), setzen wir auf Grundlage von §&nbsp;25 Abs.&nbsp;2 TDDDG sowie Art.&nbsp;6
                            Abs.&nbsp;1 lit.&nbsp;b und lit.&nbsp;f DSGVO ein. Nicht notwendige Cookies und Technologien
                            setzen wir nur mit Ihrer Einwilligung ein (§&nbsp;25 Abs.&nbsp;1 TDDDG, Art.&nbsp;6
                            Abs.&nbsp;1 lit.&nbsp;a DSGVO).</p>
                        <p>(2) Zur Einholung und Verwaltung Ihrer Einwilligungen nutzen wir die externe
                            Consent-Management-Lösung <strong>CCM19</strong> des Anbieters Papoo Software &amp; Media
                            GmbH, Auguststraße 4, 53229 Bonn. Über das eingeblendete Banner können Sie Ihre Auswahl
                            treffen und jederzeit mit Wirkung für die Zukunft ändern oder widerrufen. Im Rahmen der
                            Einwilligungsverwaltung werden insbesondere die IP-Adresse (anonymisiert), Angaben zu
                            Browser und Endgerät sowie Zeitpunkt und Umfang der Einwilligung verarbeitet, um Ihre
                            Einstellungen nachweisen und umsetzen zu können. Da CCM19 als externer Dienst eingesetzt
                            wird, haben wir mit dem Anbieter einen Vertrag zur Auftragsverarbeitung nach Art.&nbsp;28
                            DSGVO geschlossen. Rechtsgrundlage für den Einsatz ist unser berechtigtes Interesse an einer
                            rechtskonformen Einwilligungsverwaltung (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO) sowie
                            Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO.</p>

                        <h2>7. Kontaktaufnahme über das Kontaktformular und per E-Mail</h2>
                        <p>(1) Auf unserer Plattform steht ein <strong>Kontaktformular</strong> zur Verfügung. Bei
                            dessen Nutzung verarbeiten wir die von Ihnen angegebenen Daten (insbesondere <span
                                class="legal-doc__todo">[Name, E-Mail-Adresse, Nachrichtentext, ggf.
                                Telefonnummer]</span>), um Ihre Anfrage zu bearbeiten. Gleiches gilt bei einer
                            Kontaktaufnahme per E-Mail.</p>
                        <p>(2) Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO, soweit die Anfrage auf den
                            Abschluss oder die Durchführung eines Vertrags gerichtet ist, im Übrigen Art.&nbsp;6
                            Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).</p>
                        <p>(3) <strong>Hinweis:</strong> Bitte übermitteln Sie über das Kontaktformular oder per
                            unverschlüsselter E-Mail keine sensiblen Gesundheitsdaten. Für die Übermittlung solcher
                            Daten nutzen Sie bitte den geschützten Bereich der Plattform oder vereinbaren einen sicheren
                            Übermittlungsweg.</p>
                        <p>(4) Die Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet ist und keine
                            gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>

                        <h2>8. Registrierung und Nutzerkonto</h2>
                        <p>(1) Für die Nutzung der Plattform können Sie ein Nutzerkonto anlegen. Dabei verarbeiten wir
                            die von Ihnen angegebenen Stammdaten (insbesondere <span class="legal-doc__todo">[Name,
                                E-Mail-Adresse, Zugangsdaten, ggf. Anschrift und Kontaktdaten]</span>) zur
                            Bereitstellung des Kontos und der damit verbundenen Funktionen.</p>
                        <p>(2) Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO. Die Daten werden für die
                            Dauer des Bestehens des Kontos gespeichert und nach dessen Löschung entfernt, soweit keine
                            gesetzlichen Aufbewahrungspflichten bestehen.</p>

                        <h2>9. Online-Terminbuchung</h2>
                        <p>(1) Über die Plattform können Sie Termine für eine Behandlung buchen. Die Terminbuchung wird
                            <strong>innerhalb unserer eigenen Plattform</strong> abgewickelt; eine Übermittlung an einen
                            externen Buchungsdienstleister findet nicht statt.
                        </p>
                        <p>(2) Verarbeitet werden die für die Terminvereinbarung erforderlichen Daten (insbesondere
                            Name, Kontaktdaten, gewünschter Termin sowie ggf. ein Anliegen/Grund). Rechtsgrundlage ist
                            Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Durchführung vorvertraglicher Maßnahmen und des
                            Behandlungsvertrags). Soweit mit der Buchung bereits Gesundheitsdaten angegeben werden, gilt
                            zusätzlich Ziffer&nbsp;10.</p>

                        <h2>10. Behandlung und Verwaltung von Patientendaten</h2>
                        <p>(1) Im Rahmen der psychotherapeutischen Behandlung sowie der Verwaltung der
                            Patienten-Stammdaten verarbeiten wir personenbezogene Daten einschließlich
                            <strong>Gesundheitsdaten</strong> (besondere Kategorien nach Art.&nbsp;9 DSGVO). Hierzu
                            zählen insbesondere Stammdaten (Name, Kontaktdaten, Geburtsdatum), Behandlungs- und
                            Anamnesedaten, Termine sowie Abrechnungsdaten.
                        </p>
                        <p>(2) Rechtsgrundlage ist Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;h DSGVO i.&nbsp;V.&nbsp;m.
                            §&nbsp;22 Abs.&nbsp;1 Nr.&nbsp;1 lit.&nbsp;b BDSG (Verarbeitung zum Zweck der
                            Gesundheitsvorsorge und der Behandlung durch Angehörige eines Gesundheitsberufs, die einer
                            Geheimhaltungspflicht unterliegen) sowie – soweit erforderlich – Ihre ausdrückliche
                            Einwilligung nach Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a DSGVO. Für die zugrunde liegende
                            Vertragsbeziehung gilt zusätzlich Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO.</p>
                        <p>(3) <strong>Schweigepflicht:</strong> Wir unterliegen der gesetzlichen Schweigepflicht nach
                            §&nbsp;203 StGB. Ihre Gesundheitsdaten werden vertraulich behandelt und nur an Dritte
                            weitergegeben, wenn dies gesetzlich erlaubt oder vorgeschrieben ist oder Sie ausdrücklich
                            eingewilligt haben.</p>
                        <p>(4) <strong>Empfänger:</strong> Eine Weitergabe erfolgt nur, soweit erforderlich, z.&nbsp;B.
                            an <span class="legal-doc__todo">[ggf. privatärztliche Verrechnungsstelle, Steuerberater,
                                weiterbehandelnde Stellen]</span> und nur auf einer der vorgenannten Rechtsgrundlagen.
                            Soweit Dienstleister im Auftrag tätig werden (z.&nbsp;B. Hosting), erfolgt dies auf
                            Grundlage eines Auftragsverarbeitungsvertrags nach Art.&nbsp;28 DSGVO.</p>
                        <p>(5) <strong>Speicherdauer:</strong> Behandlungsdokumentationen bewahren wir entsprechend den
                            berufs- und gesetzlichen Vorgaben auf, in der Regel 10&nbsp;Jahre nach Abschluss der
                            Behandlung. Längere Aufbewahrungsfristen aufgrund steuer- oder handelsrechtlicher Vorgaben
                            (siehe Ziffer&nbsp;16) bleiben unberührt.</p>

                        <h2>11. Abrechnung der Heilpraktikerleistungen</h2>
                        <p>(1) Zur Abrechnung der erbrachten Leistungen verarbeiten wir die hierfür erforderlichen
                            Stamm- und Leistungsdaten (insbesondere Name, Anschrift, erbrachte Leistungen, Honorar) und
                            erstellen Rechnungen.</p>
                        <p>(2) Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Vertragserfüllung), für
                            die Verarbeitung der zugrunde liegenden Gesundheitsdaten Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;h
                            DSGVO i.&nbsp;V.&nbsp;m. §&nbsp;22 BDSG sowie Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO im
                            Hinblick auf steuerrechtliche Pflichten. Es gelten die gesetzlichen Aufbewahrungsfristen
                            (siehe Ziffer&nbsp;16).</p>

                        <h2>12. Digitale Inhalte und Abonnements</h2>
                        <p>(1) Beim Erwerb digitaler Inhalte und beim Abschluss von Abonnements verarbeiten wir die zur
                            Vertragsabwicklung erforderlichen Daten (insbesondere Bestelldaten, Zahlungsdaten, Angaben
                            zum Nutzungsumfang sowie Daten zur Bereitstellung und Freischaltung der Inhalte).</p>
                        <p>(2) Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO. Daten, die handels- und
                            steuerrechtlichen Aufbewahrungspflichten unterliegen, speichern wir entsprechend den
                            gesetzlichen Fristen (siehe Ziffer&nbsp;16).</p>

                        <h2>13. Zahlungsabwicklung</h2>
                        <p>(1) <strong>Stripe.</strong> Für die Abwicklung von Zahlungen setzen wir den
                            Zahlungsdienstleister <strong>Stripe</strong> ein (Stripe Payments Europe, Limited, 1 Grand
                            Canal Street Lower, Grand Canal Dock, Dublin, Irland). Über Stripe werden die angebotenen
                            Zahlungsarten – Kreditkarte, SEPA-Lastschrift und PayPal – abgewickelt. Bei einer Zahlung
                            werden die hierfür erforderlichen Daten (z.&nbsp;B. Name, Rechnungsbetrag,
                            Zahlungsmittel-/Kontodaten) an Stripe übermittelt und dort verarbeitet. Vollständige
                            Zahlungsmitteldaten speichern wir selbst nicht. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1
                            lit.&nbsp;b DSGVO. Weitere Informationen: <a href="https://stripe.com/de/privacy"
                                target="_blank" rel="noopener">stripe.com/de/privacy</a>.</p>
                        <p>(2) <strong>PayPal.</strong> Wählen Sie die Zahlungsart PayPal, werden zur Abwicklung
                            zusätzlich Daten an die PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, 2449
                            Luxemburg, übermittelt. Es gelten ergänzend die Datenschutzbestimmungen von PayPal.</p>
                        <p>(3) Im Rahmen der Zahlungsabwicklung kann es zu einer Übermittlung von Daten in Drittländer
                            kommen (siehe Ziffer&nbsp;15).</p>

                        <h2>14. Mobile Apps (iOS und Android)</h2>
                        <p>(1) Wir bieten die Plattform auch als App für <strong>iOS</strong> und
                            <strong>Android</strong> an. Beim Download der App über den jeweiligen App-Store (Apple
                            Distribution International Ltd., Irland, bzw. Google Ireland Ltd., Irland) werden Daten
                            durch den jeweiligen Store-Betreiber als eigenständig Verantwortlicher verarbeitet; hierauf
                            haben wir keinen Einfluss. Es gelten die Datenschutzbestimmungen des jeweiligen Anbieters.
                        </p>
                        <p>(2) Innerhalb der App verarbeiten wir dieselben Daten wie bei der Web-Nutzung (insbesondere
                            Login, Terminbuchung, Zugriff auf Inhalte) zu den unter dieser Erklärung genannten Zwecken
                            und Rechtsgrundlagen.</p>
                        <p>(3) <span class="legal-doc__todo">[Bitte ergänzen/streichen je nach Einsatz:
                                Push-Benachrichtigungen (nur mit Einwilligung, Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a
                                DSGVO), Absturz-/Fehlerberichte (z.&nbsp;B. Sentry, Firebase Crashlytics),
                                Geräteberechtigungen (z.&nbsp;B. Kamera/Benachrichtigungen).]</span></p>

                        <h2>15. Datenübermittlung in Drittländer</h2>
                        <p>Soweit Daten an Empfänger außerhalb der EU/des EWR übermittelt werden (z.&nbsp;B. an Stripe,
                            PayPal, Apple oder Google bzw. deren Konzerngesellschaften in den USA), erfolgt dies nur,
                            wenn ein angemessenes Datenschutzniveau gewährleistet ist. Grundlage hierfür sind
                            insbesondere der Angemessenheitsbeschluss der EU-Kommission im Rahmen des <strong>EU-US Data
                                Privacy Framework</strong> (soweit der Empfänger zertifiziert ist) und/oder die
                            <strong>Standardvertragsklauseln</strong> der EU-Kommission nach Art.&nbsp;46 DSGVO. <span
                                class="legal-doc__todo">[Beim jeweiligen Dienstleister verifizieren.]</span>
                        </p>

                        <h2>16. Speicher- und Löschfristen</h2>
                        <p>Wir verarbeiten und speichern personenbezogene Daten nur so lange, wie dies für den
                            jeweiligen Zweck erforderlich ist. Anschließend werden die Daten gelöscht, sofern keine
                            gesetzlichen Aufbewahrungspflichten entgegenstehen. Insbesondere gelten:</p>
                        <ul>
                            <li>Behandlungsdokumentation: in der Regel 10&nbsp;Jahre,</li>
                            <li>handels- und steuerrechtlich relevante Unterlagen (z.&nbsp;B. Rechnungen): grundsätzlich
                                8 bzw. 10&nbsp;Jahre nach den §§&nbsp;257 HGB, 147 AO.</li>
                        </ul>

                        <h2>17. Datensicherheit</h2>
                        <p>Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten gegen Verlust,
                            Manipulation und unberechtigten Zugriff zu schützen. Die Datenübertragung im Internet
                            erfolgt verschlüsselt (TLS). Das eingesetzte Rechenzentrum ist nach ISO/IEC&nbsp;27001
                            zertifiziert.</p>

                        <h2>18. Keine automatisierte Reichweitenmessung</h2>
                        <p>Derzeit setzen wir <strong>keine</strong> Webanalyse- oder Reichweitenmessungs-Dienste
                            (z.&nbsp;B. Google Analytics, Matomo) und kein Tracking zu Marketingzwecken ein. Sollte sich
                            dies künftig ändern, werden wir diese Datenschutzerklärung entsprechend anpassen und –
                            soweit erforderlich – vorab Ihre Einwilligung einholen.</p>

                        <h2>19. Aktualität und Änderung dieser Datenschutzerklärung</h2>
                        <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand {{ lastUpdated }}. Durch die
                            Weiterentwicklung der Plattform oder aufgrund geänderter gesetzlicher bzw. behördlicher
                            Vorgaben kann es erforderlich werden, diese Datenschutzerklärung anzupassen.</p>

                        <p class="legal-doc__updated">Stand: {{ lastUpdated }}</p>
                    </article>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-container>
    </div>
</template>

<script>

export default {
    name: "privacy",

    data() {
        return {
            lastUpdated: 'Mai 2026',
            obfuscatedEmail: "kontakt[at]praxis-keilberg[dot]de",
            obfuscatedPhone: "+49-1515-0850942"
        }
    },
    computed: {
        email() {
            return this.obfuscatedEmail
                .replace('[at]', '@')
                .replace('[dot]', '.')
        },
        mailto() {
            return `mailto:${this.email}`
        },

        phone() {
            return this.obfuscatedPhone
                .replaceAll('-', '')
        },

        phoneHref() {
            return `tel:${this.obfuscatedPhone.replaceAll('-', '')}`
        }
    },

    computed: {
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
    }
}

</script>


<style scoped>
.legal-doc {
    margin-inline: auto;
    padding: clamp(1.25rem, 4vw, 2.5rem);
    font-family: inherit;
    font-size: 1rem;
    line-height: 1.7;
    text-align: left;
    -webkit-text-size-adjust: 100%;
}

.legal-doc__title {
    font-size: clamp(1.6rem, 4vw, 2.1rem);
    line-height: 1.25;
    font-weight: 700;
    margin: 0 0 1.5rem;
    letter-spacing: -0.01em;
}

.legal-doc :is(h2) {
    font-size: 1.2rem;
    font-weight: 700;
    margin: 2.4rem 0 0.75rem;
    padding-bottom: 0.4rem;
}

.legal-doc :is(h3) {
    font-size: 1.02rem;
    font-weight: 700;
    margin: 1.6rem 0 0.5rem;
}

.legal-doc p {
    margin: 0 0 0.9rem;
}

.legal-doc ul {
    margin: 0 0 0.9rem;
    padding-left: 1.4rem;
}

.legal-doc li {
    margin: 0 0 0.45rem;
}

.legal-doc a {
    color: rgb(var(--v-theme-primary));
    text-decoration: underline;
    text-underline-offset: 2px;
    overflow-wrap: anywhere;
}

.legal-doc strong {
    font-weight: 700;
}

.legal-doc address {
    font-style: normal;
    margin: 0 0 0.9rem;
}

.legal-doc__box {
    border-radius: 8px;
    padding: 1rem 1.25rem;
    margin: 0 0 1rem;
}

.legal-doc__box p:last-child {
    margin-bottom: 0;
}

.legal-doc__muted {
    opacity: 0.7
}

.legal-doc__updated {
    margin-top: 2.5rem;
    font-size: 0.9rem;
}

.legal-doc__todo {
    padding: 0 0.25em;
    border-radius: 3px;
    font-style: italic;
}
</style>
